export class ProductPaymentData {
    name: string;
    price: number;
    quantity: number;
    suscriptionType: number;
    complements = {
        fotoINE: false,
        sms: false,
        constanciaUSA: false,
        constanciaBlockChain: false,
        ineFirma: false,
        otpWhatsapp: false,
        ineFirmaVideoFirma: false,
        ineFirmaVideoAcuerdo: false
    };
}
